import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextArea,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Toggle,
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import DateTimePicker from '../../helpers/DateTimePicker';

export class IncidentEventModal extends Component {
  incidentEventModel = (props) => {
    if (props.isEditModal) {
      return { ...props.editModel };
    }

    return {
      id: null, //guid
      occurredAt: null, //datetime
      briefDescription: '', //string
      anomaly: false, //bool
      idIncident: null, //guid
    };
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});    
    this.validatorTime = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
    this.state = {
      flagTime : false,
      model: {
        ...this.incidentEventModel(props),
      },
    };
  }

  updateStatesTime = (inputName, inputValue, objName) => {    
    if(inputValue==false){
      this.setState({flagTime:true});
    if (this.validatorTime.allValid()) {
      this.validatorTime.showMessages();
      }}
    else{
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;
    statusCopy.flagTime = false;
    this.setState(statusCopy);
    }
  }

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;

    let statusCopy = Object.assign({}, this.state.model);
    statusCopy[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };

  handleToggle = (value, id) => {
    //onchange toggle widget
    this.setState((prevState) => ({
      model: {
        ...prevState.model,
        [id]: value,
      },
    }));
  };

  save = () => {
    if (this.validator.allValid()) {
      if(!this.validatorTime.allValid()){
      this.props.save(this.state.model);
      showNotification.success(`${entitiesLabels.SUCCESS}`,'Event created successfully');
    }
    else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
         entitiesLabels.INCIDENT + ' time is invalid '
      );
    }}
    else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
         entitiesLabels.INCIDENT + ' required fields are missing  '
      );
    this.forceUpdate();
    }
  };


  render() {
    const validationsTime = {
      validTime: this.validatorTime.message(
        'validTime',
        this.state.flagTime,
        'accepted'
      ),  
    }
    const validations = {
      // immediateActions: this.validator.message('immediateActions', this.state.hocCardModel.immediateActions, 'required'),
      occurredAt: this.validator.message('occurredAt', this.state.model.occurredAt, 'required'),
      briefDescription: this.validator.message(
        'briefDescription',
        this.state.model.briefDescription,
        'required'
      ),
       };
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    return (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          {
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="Occurred At*" className="bx--col--md-6 bx--col-lg-6">
                  <DateTimePicker
                    value={this.state.model.occurredAt}
                    type="datetime"
                    placeholder="DD/MM/YYYY hh:mm AM/PM"
                    name="occurredAt"
                    alt="model"
                    invalid={validations.occurredAt != null}
                    onChange={this.updateStatesTime}
                  />
                  {validations.occurredAt || validations.time}
                  {this.state.flagTime? (
                          <div className="srv-validation-message "> Invalid time format </div>
                        ): null}   
                </FormGroup>
                <FormGroup legendText="Anomaly" className="bx--col--md-6 bx--col-lg-6">
                  <Toggle
                    id="anomaly"
                    aria-label=""
                    labelText=""
                    labelA="No"
                    labelB="Yes"
                    toggled={this.state.model.anomaly || false}
                    onToggle={this.handleToggle}
                  />
                </FormGroup>
                <FormGroup legendText="Brief Description* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP)​)" className="bx--col--md-12 bx--col-lg-12">
                  <TextArea
                    maxLength={5000}
                    id="eventBriefDescription"
                    placeholder="Brief description"
                    name="briefDescription"
                    value={this.state.model.briefDescription || ''}
                    onChange={this.handleChangeModel}
                    hideLabel={true}
                    labelText=""
                    light
                    rows={8}
                    cols={100}
                    invalid={validations.briefDescription != null}
                  />
                  {validations.briefDescription}
                </FormGroup>
              </div>
            </div>
          }
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

IncidentEventModal.propTypes = {
  save: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEditModal: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  // mode: PropTypes.number,
  // title: PropTypes.string,
  // appType: PropTypes.array,
  // appNationality: PropTypes.array,
  // appInjuryType: PropTypes.array,
};
